export default {"src":"/_next/static/media/rating-4.005f04bf.svg","height":96,"width":512,"blurWidth":0,"blurHeight":0};